import StatusPage from "./statusPage";

function App() {
  return <StatusPage />;
}
export default App;
